<!--
  Discount delta cell (§4.6/§5). Signed pp, direction-coloured. The sign +
  " pp" unit is always present so colour is never the sole signal (NFR8).
  pp only — never `$`.
-->
<span class="pf-delta" [ngClass]="colourClass" [attr.aria-label]="ariaLabel">{{ display }}</span>
